import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ParaglidingIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"paragliding"} ref={ref}/>
});

ParaglidingIcon.displayName = "ParaglidingIcon";
